import { getApiUrl } from '../utils/apiUrl';

const API_BASE = getApiUrl();

/**
 * Fetch the current user's permissions
 * @param {string} token - JWT token
 * @returns {Promise<Object>} User permissions object
 */
export async function fetchUserPermissions(token) {
  const response = await fetch(`${API_BASE}/user/permissions`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch user permissions');
  }

  return response.json();
}

/**
 * Fetch permissions for an arbitrary user (admin only).
 * Used by the "view main page as user" admin feature.
 * @param {number} userId - Target user id
 * @param {string} token - JWT token
 * @returns {Promise<Object>} User permissions object
 */
export async function fetchUserPermissionsById(userId, token) {
  const response = await fetch(`${API_BASE}/user/permissions/${userId}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });

  if (!response.ok) {
    throw new Error('Failed to fetch user permissions');
  }

  return response.json();
}
